import { ZipResultsCampaign } from 'entities/campaign';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';

export interface ZipsResultsBlockProps {
  campaignId: number;
  validCount?: number;
  duplicateCount?: number;
  invalidCount?: number;
  className?: string;
}

export function ZipsResultsBlock({
  campaignId,
  validCount,
  duplicateCount,
  invalidCount,
  className,
}: ZipsResultsBlockProps) {
  const onlyInvalidZips = !validCount && !duplicateCount && Boolean(invalidCount);

  return (
    <div className={className}>
      <ZipResultsCampaign
        type="valid"
        titleCounter={validCount}
        campaignId={campaignId}
        resultType="campaign"
        {...getDataAutoTestAttributes(['zip-validation-block-valid'])}
      />
      <ZipResultsCampaign
        className="mt-4"
        type="duplicate"
        titleCounter={duplicateCount}
        campaignId={campaignId}
        resultType="campaign"
        {...getDataAutoTestAttributes(['zip-validation-block-duplicate'])}
      />
      <ZipResultsCampaign
        className="mt-4"
        type="invalid"
        titleCounter={invalidCount}
        campaignId={campaignId}
        onlyInvalid={onlyInvalidZips}
        resultType="campaign"
        {...getDataAutoTestAttributes(['zip-validation-block-invalid'])}
      />
    </div>
  );
}
